import { render } from "./OrderCreateShopWholesale.vue?vue&type=template&id=2d492ecd"
import script from "./OrderCreateShopWholesale.vue?vue&type=script&lang=js"
export * from "./OrderCreateShopWholesale.vue?vue&type=script&lang=js"

import "./OrderCreateShopWholesale.vue?vue&type=style&index=0&id=2d492ecd&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__